import React, { useState, useRef } from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material/";
import { useForm } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import FormHorizontalSection from "./FormHorizontalSection";
import FormActions from "./FormActions";
import SlideForm from "./SlideForm";

export const StepTwo = (props) => {
    const { stepState } = props;
    const [cv, setCv] = useState("");
    const cvRef = useRef();
    const {
        register,
        setError,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            ...stepState.stepTwoData
        },
    });

    /**
     * Validates the selected CV file to ensure that it meets the necessary requirements.
     *
     * TODO: Refactor and move this function to a reusable utilities directory. Also, error messages
     * should be stored in a centralized location, such as errors.json
     *
     * @param {File} cv - The selected CV file to validate.
     * @param {function} setError - The setError function from react-hook-form used to set the validation error.
     * @returns {void}
     */
    const validateCV = (cv) => {
        if (!cv) return;

        // Check if the file is a PDF
        if (cv.type !== "application/pdf") {
            setError("cv", {
                type: "manual",
                message: "CV should be in PDF format",
            });
            return;
        }

        // Check if the file size is less than or equal to 3 megabytes
        if (cv.size > 3 * 1024 * 1024) {
            setError("cv", {
                type: "manual",
                message: "CV size should be less than or equal to 3 MB",
            });
            return;
        }
    };

    const onSubmit = (formData, event) => {
        validateCV(cv);
        formData.step = 2;
        formData.cv = cv;
        const payload = {
            ...formData,
            step: 2,
            cv,
        };
        stepState.formSubmit(payload, event);
    };

    return (
        <SlideForm stepState={{ ...stepState }}>
            <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <FormHorizontalSection
                    sx={{ my: 4 }}
                    title="Personal Information"
                >
                    {/* Upload CV */}
                    <Box sx={{ display: "flex", maxWidth: "600px" }} gap={2}>
                        <TextField
                            name="cv"
                            fullWidth
                            defaultValue={cv}
                            InputLabelProps={{ shrink: true }}
                            {...register("cv")}
                            error={Boolean(errors.cv)}
                            helperText={errors.cv ? errors.cv.message : ""}
                            InputProps={{
                                accept: "application/pdf",
                                inputMode: "file",
                                endAdornment: cv && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Clear"
                                            onClick={() => {
                                                setCv(null);
                                                cvRef.current.value = "";
                                            }}
                                        >
                                            <ClearIcon
                                                color="grey"
                                                fontSize="14px"
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            type="file"
                            label="Upload CV"
                            inputRef={cvRef}
                            onChange={(event) => setCv(event.target.files[0])}
                        />
                    </Box>

                </FormHorizontalSection>
                <FormActions stepState={{ ...stepState }} />
            </Box>
        </SlideForm>
    );
};

export default StepTwo;
